module.exports = __webpack_public_path__ + "img/broadcast-work-icon4.c03d50ed.png";